<template>
  <td>{{ percentage }} %</td>
</template>

<script>
export default {
  props: ["model", "attribute"],
  computed: {
    secondAttribute() {
      return this.attribute.secondAttribute;
    },
    percentage() {
      let percent = (
        (parseInt(this.model.typeCount, 10) /
          parseInt(this.secondAttribute, 10)) *
        100
      ).toFixed(2);
      return percent.replace(".", ",");
    }
  }
};
</script>
